import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoginContext } from '../../../context/LoginContext';
import { SignupContext } from '../../../context/SignupContext';
import thankYouBg from '../../../assets/images/thankyou/thankyou-bg.png';

const DASHBOARD_PATH = '/recently-joined-matches/';

const RegistrationThankYou = () => {
  const navigate = useNavigate();
  const { isLoggedIn, userData, setIsLoggedIn, setUserId, setUserdata } = useContext(LoginContext);
  const { isLoggedIn: signupLoggedIn, userId: signupUserId } = useContext(SignupContext);

  useEffect(() => {
    try {
      sessionStorage.removeItem('hs_reg_thankyou');
    } catch (_) {}

    if (!isLoggedIn && (signupLoggedIn || userData?.user_id || Number(userData?.status) === 1)) {
      setIsLoggedIn(true);
      const uid = signupUserId || userData?.user_id || userData?.id;
      if (uid) setUserId(uid);
      if (userData && Number(userData.status) !== 1) {
        setUserdata({ ...userData, status: 1 });
      }
      return;
    }

    if (!isLoggedIn && !signupLoggedIn && !userData?.user_id) {
      navigate('/login/', { replace: true });
    }
  }, [
    isLoggedIn,
    signupLoggedIn,
    signupUserId,
    userData,
    navigate,
    setIsLoggedIn,
    setUserId,
    setUserdata,
  ]);

  return (
    <div
      className="reg-thankyou-page"
      style={{ backgroundImage: `url(${thankYouBg})` }}
    >
      <main className="reg-thankyou-content">
        <h1 className="reg-thankyou-title">
          Thank <span className="reg-thankyou-accent">You!</span>
        </h1>
        <p className="reg-thankyou-subtitle">
          Your registration has been completed successfully. We&apos;re happy to have
          you with us on this journey towards a brighter tomorrow.
        </p>
        <Link to={DASHBOARD_PATH} className="reg-thankyou-btn" replace>
          Continue to Home →
        </Link>
      </main>

      <style>{`
        .reg-thankyou-page {
          min-height: 100vh;
          min-height: 100dvh;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff8fb;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          padding: 2rem 1.25rem;
          box-sizing: border-box;
        }
        .reg-thankyou-content {
          text-align: center;
          max-width: 560px;
          width: 100%;
          position: relative;
          z-index: 1;
        }
        .reg-thankyou-title {
          margin: 0 0 1.15rem;
          font-size: clamp(2.6rem, 7vw, 3.75rem);
          font-weight: 700;
          line-height: 1.12;
          color: #2b2b2b;
          font-family: Georgia, 'Times New Roman', Times, serif;
          letter-spacing: -0.02em;
        }
        .reg-thankyou-accent {
          color: #e14d84;
        }
        .reg-thankyou-subtitle {
          margin: 0 auto 2.1rem;
          max-width: 420px;
          font-size: clamp(0.95rem, 2.2vw, 1.05rem);
          line-height: 1.6;
          color: #6b7280;
          font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
          font-weight: 400;
        }
        .reg-thankyou-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.4rem;
          background: #e14d84;
          color: #fff !important;
          text-decoration: none;
          padding: 0.9rem 2rem;
          border-radius: 999px;
          font-weight: 600;
          font-size: 1rem;
          font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
          box-shadow: 0 8px 24px rgba(225, 77, 132, 0.28);
          transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
        }
        .reg-thankyou-btn:hover {
          background: #cb3f73;
          color: #fff !important;
          transform: translateY(-1px);
          box-shadow: 0 10px 28px rgba(225, 77, 132, 0.34);
        }
        @media (max-width: 576px) {
          .reg-thankyou-page {
            padding: 1.5rem 1rem;
            background-size: cover;
          }
          .reg-thankyou-subtitle {
            margin-bottom: 1.75rem;
          }
          .reg-thankyou-btn {
            width: 100%;
            max-width: 300px;
          }
        }
      `}</style>
    </div>
  );
};

export default RegistrationThankYou;
